<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
    <vue2-tinymce-editor v-model="item.description" :options="defaultToolbar"></vue2-tinymce-editor>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import {Vue2TinymceEditor} from "vue2-tinymce-editor";

export default {
  name: "CombinationText",
  components: {Vue2TinymceEditor,},
  props: {
    item: {}
  },
  data() {
    return {
      defaultToolbar,
    }
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.item-head .form-control {
  flex: 0 0 200px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
}
</style>